import { useTransaction } from "hooks/useTransactions";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import React, { useState } from "react";
import { bool } from "prop-types";
import { Col, Row } from "react-bootstrap";
import * as i18n from "util/i18n";
import gaEventTracker, { events } from "util/gaEventTracker";
import { transactionStatus } from "pages/transactions/constants";
import { actions as comexActions } from "reducers/comex";
import ComexTransactionBody from "./_components/TransactionBody";
import { ResponsiveHeader } from "pages/_components/header";

const ComexTransactionPage = ({ isDesktop }) => {
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const formatTransactionTransfer = (data, idTransaction) => ({ ...data, idTransaction });

    const {
        isLoading,
        transaction,
        dispatch,
        handleSignTransaction,
        showSignButton,
        push,
        id,
        status,
    } = useTransaction(`/comex/confirm`, comexActions.setComexTransfer, null, formatTransactionTransfer);

    const { isFinished, isPending, isBackoffice, isFlowComplete, isCancelled, isFailed } = status;

    const isAwaiting = transaction?.data?.awaitingApproval || false;
    const _transactionStatus = isAwaiting && isPending ? transactionStatus.AWAITING : transaction.idTransactionStatus;

    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "transfers.comex.title",
        id,
        "OtherTransferTransaction",
    );

    const getMdOffset = () => {
        if (isFinished || isAwaiting || showSignButton) {
            return 2;
        }
        return 4;
    };

    const handleSign = () => {
        gaEventTracker.triggerEvent(events.trans_pagos_firmar());
        return handleSignTransaction();
    };

    const handleDownload = async () => {
        await setShowMoreData(true);
        gaEventTracker.triggerEvent(events.trans_pagos_descargar());
        return handlePrint();
    };

    const backLinkTo = isFlowComplete || isFinished || isPending ? "/comex" : "";

    return (
        <>
            {isFinished && <Notification scopeToShow="OtherTransferTransaction" />}
            <ResponsiveHeader
                ticket
                id="transfers.comex.title"
                metaTitle="transfers.comex.title"
                backLinkTo={backLinkTo}
            />
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader
                                title="transfers.comex.title"
                                subTitle={`comex.ticket.status.${_transactionStatus}`}
                                status={_transactionStatus}
                            />

                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <ComexTransactionBody
                                        setShowMoreData={setShowMoreData}
                                        showMoreData={showMoreData}
                                        isDesktop={isDesktop}
                                    />

                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            <Col xs={12} md={4} mdOffset={getMdOffset()}>
                                <Button
                                    onClick={() => dispatch(push("/desktop"))}
                                    label="forms.transaction.ticket.actions.backToHome"
                                    className={`btn${
                                        isFinished || isAwaiting || showSignButton ? " btn-outline" : " btn-primary"
                                    }`}
                                />
                            </Col>
                            
                                 {(isFinished || isAwaiting || isCancelled || isFailed) && (
                                     <>
                                    <Col xs={12} md={4}>
                                    <Button
                                        className="btn btn-primary"
                                        image="images/figma/icon/download.svg"
                                        label="global.download"
                                        onClick={handleDownload}
                                    />
                                     </Col>
                                     </>
                                 )}
                               
                                    {!isDesktop && (
                                        <Col xs={12} md={4}>
                                            <Button
                                                className="btn btn-outline"
                                                image="images/figma/icon/share.svg"
                                                label="global.share"
                                                onClick={() => {
                                                    handleShareMobile();
                                                }}
                                            />
                                        </Col>
                                    )}
                                {showSignButton && (
                                    <Col xs={12} md={4}>
                                        <Button
                                            onClick={handleSign}
                                            label="forms.signTransaction.link"
                                            className="btn btn-primary"
                                        />
                                    </Col>
                                )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

ComexTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default ComexTransactionPage;
